const SAFE_KEY = /^[a-z][a-z0-9_]{0,39}$/;

function cleanParams(params = {}) {
  return Object.fromEntries(Object.entries(params)
    .filter(([key, value]) => SAFE_KEY.test(key) && ['string', 'number', 'boolean'].includes(typeof value))
    .map(([key, value]) => [key, typeof value === 'string' ? value.slice(0, 100) : value]));
}

export function trackGrowthEvent(eventName, params = {}) {
  if (!SAFE_KEY.test(String(eventName || '')) || typeof window === 'undefined' || typeof window.gtag !== 'function') return false;
  window.gtag('event', eventName, cleanParams(params));
  return true;
}

export function trackPublicPageView(pathname, title = '') {
  return trackGrowthEvent('page_view', {
    page_path: pathname,
    page_title: title,
    page_location: typeof window !== 'undefined' ? window.location.href : '',
  });
}
